export default {
  ALL:       'all',
  DRAFT:     'draft',
  READY:     'ready',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'live',
  EXPIRED:   'expired',
  TEMPLATE:  'template',
};
